/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import apiRequest from '../api/api.request';
import endpoints from '../../../constants/endpoints';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
import {
	generateOtpAction,
	generateOtpResultFailedAction,
	generateOtpResultSuccessAction,
	IGenerateOtpRequest,
	IGenerateOtpResponse,
	IMatchOtpRequest,
	IMatchOtpResponse,
	INewPasswordRequest,
	INewPasswordSuccess,
	matchOtpRequestAction,
	matchOtpResultFailedAction,
	matchOtpResultSuccessAction,
	newPasswordFailedAction,
	newPasswordRequestAction,
	newPasswordSuccessAction,
	toggleOtpModalAction,
} from '../actions/ForgotPasswordAction';
import environment from '../../../environments/environment';

function* generateOtp({
	payload,
}: {
	payload: IGenerateOtpRequest;
}): Generator {
	const auth = `${environment.authUsername}:${environment.authPassword}`;
	const config: ApiRequestConfig = {
		path: endpoints.api.GENERATE_OTP,
		method: 'POST',
		headers: {
			Authorization: `Basic ${btoa(auth)}`,
		},
		query: null,
		body: payload,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		yield put(generateOtpResultSuccessAction(data as IGenerateOtpResponse));
		return res;
	} catch (err) {
		yield put(generateOtpResultFailedAction(err as string));
		return err;
	}
}

function* setGenerateOtpResult({
	payload,
}: {
	payload: IGenerateOtpResponse;
}): Generator {
	yield put(toggleOtpModalAction(true));
	return payload;
}

function* matchOtp({ payload }: { payload: IMatchOtpRequest }): Generator {
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const config: ApiRequestConfig = {
		path: endpoints.api.MATCH_OTP,
		method: 'POST',
		headers: {},
		query: null,
		body: payload,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		yield put(matchOtpResultSuccessAction(data as IMatchOtpResponse));
		return res;
	} catch (err) {
		yield put(matchOtpResultFailedAction(err as string));
		return err;
	}
}

function* matchOtpSuccess({
	payload,
}: {
	payload: IMatchOtpResponse;
}): Generator {
	if (payload.isMatch) {
		yield put(toggleOtpModalAction(false));
	} else {
		yield put(
			matchOtpResultFailedAction(
				'kode verifikasi yang anda masukan salah'
			)
		);
	}
	return payload;
}

function* setNewPassword({
	payload,
}: {
	payload: INewPasswordRequest;
}): Generator {
	const matchOtpResponse = (yield select(
		(state: {
			forgotPasswordReducer: { matchOtpState: { response: IMatchOtpResponse } };
		}) => state.forgotPasswordReducer.matchOtpState.response
	)) as IMatchOtpResponse;
	const body: INewPasswordRequest = {
		...payload,
		forgotPasswordToken:
			payload.forgotPasswordToken ||
			matchOtpResponse.purpose_data?.forgot_pasword_token ||
			'',
	};
	const auth = `${environment.authUsername}:${environment.authPassword}`;
	const config: ApiRequestConfig = {
		path: endpoints.api.FORGOT_PASSWORD,
		method: 'PUT',
		headers: {
			Authorization: `Basic ${btoa(auth)}`,
		},
		query: null,
		body,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		yield put(newPasswordSuccessAction(data as INewPasswordSuccess));
		return res;
	} catch (err) {
		yield put(newPasswordFailedAction(err as string));
		return err;
	}
}

function setNewPasswordSuccess({
	payload,
}: {
	payload: INewPasswordSuccess;
}): INewPasswordSuccess {
	return payload;
}

function toggleOtpModal({ payload }: { payload: boolean }): boolean {
	return payload;
}

export default function* forgotPasswordSaga(): Generator {
	yield takeLatest(generateOtpAction, generateOtp);
	yield takeLatest(newPasswordRequestAction, setNewPassword);
	yield takeLatest(matchOtpRequestAction, matchOtp);
	yield takeEvery(generateOtpResultSuccessAction, setGenerateOtpResult);
	yield takeEvery(matchOtpResultSuccessAction, matchOtpSuccess);
	yield takeEvery(newPasswordSuccessAction, setNewPasswordSuccess);
	yield takeEvery(toggleOtpModalAction, toggleOtpModal);
}
